import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GameConfig } from "../../models/GameConfig";
import { Game } from "../../models/Games";
import { fetchData, postData } from '../../services/ApiService';
import {
  closeCircularProgress,
  openCircularProgress,
} from "../uireducers/progress";
import { User } from "../../models/Users";
import { GameManagerPermission } from "../../models/GameManagerPermission";


// Logic to Get All Templates
export const getAllGames = createAsyncThunk(
  "gameEntity/getAllGames",
  async (data, thunkAPI) => {
    // Open the Circular Progress
    thunkAPI.dispatch(openCircularProgress());

    try {
      const response = await fetchData("games"); // Specify the type if known
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return response; // Return the fetched data
    } catch (error: any) {
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
    //  return thunkAPI.rejectWithValue(error instanceof Error ? error.message : error); // Handle the error appropriately
      return thunkAPI.rejectWithValue(error?.message); // Handle the error appropriately
    }
  }
);

// Logic to Get All Templates
export const getAllGameConfig = createAsyncThunk(
    "gameEntity/getAllGameConfig",
    async (offset: number, thunkAPI) => {
      // Open the Circular Progress
      thunkAPI.dispatch(openCircularProgress());
  
      try {
        const response = await fetchData(`games/configs?offset=${offset}`); // Specify the type if known
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return response; // Return the fetched data
      } catch (error: any) {
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return thunkAPI.rejectWithValue(error?.message); // Handle the error appropriately
      }
    }
  );

  // Logic to Get All Templates
export const getAllActiveGameConfigs = createAsyncThunk(
  "gameEntity/getAllActiveGameConfigs",
  async (data, thunkAPI) => {
    // Open the Circular Progress
    thunkAPI.dispatch(openCircularProgress());

    try {
      const response = await fetchData(`games/configs/active`); // Specify the type if known
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return response; // Return the fetched data
    } catch (error: any) {
      // Close the Circular Progress
      thunkAPI.dispatch(closeCircularProgress());
      return thunkAPI.rejectWithValue(error?.message); // Handle the error appropriately
    }
  }
);


// Logic to save game
export const saveGame = createAsyncThunk(
  "gameEntity/saveGame",
  async (data: Game, thunkAPI) => {
      // Open the Circular Progress
      thunkAPI.dispatch(openCircularProgress());

      try {
        const response = await postData(`games`, data); // Specify the type if known
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return response; // Return the fetched data
      } catch (error: any) {
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return thunkAPI.rejectWithValue(error?.message); // Handle the error appropriately
      }
  }
);

// Logic to toggle game status
export const toggleGameStatus = createAsyncThunk(
  "gameEntity/toggleGameStatus",
  async (gameId: number, thunkAPI) => {
      // Open the Circular Progress
      thunkAPI.dispatch(openCircularProgress());

      try {
        const response = await fetchData(`games/${gameId}/toggle`); // Specify the type if known
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return response; // Return the fetched data
      } catch (error: any) {
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return thunkAPI.rejectWithValue(error?.message); // Handle the error appropriately
      }
  }
);

// Logic to toggle game status
export const toggleGameConfigStatus = createAsyncThunk(
  "gameEntity/toggleGameConfigStatus",
  async (gameConfigId: number, thunkAPI) => {
      // Open the Circular Progress
      thunkAPI.dispatch(openCircularProgress());

      try {
        const response = await postData(`games/configs/${gameConfigId}/toggle`, null); // Specify the type if known
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return response; // Return the fetched data
      } catch (error: any) {
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return thunkAPI.rejectWithValue(error?.message); // Handle the error appropriately
      }
  }
);

// Logic to save game config
export const saveGameConfig = createAsyncThunk(
  "gameEntity/saveGameConfig",
  async (data: GameConfig, thunkAPI) => {
      // Open the Circular Progress
      thunkAPI.dispatch(openCircularProgress());

      try {
        const response = await postData(`games/configs`, data); // Specify the type if known
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return response; // Return the fetched data
      } catch (error: any) {
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return thunkAPI.rejectWithValue(error?.message); // Handle the error appropriately
      }
  }
);

// Logic to save game config
export const addBet = createAsyncThunk(
  "gameEntity/addBet",
  async (data: any, thunkAPI) => {
      // Open the Circular Progress
      thunkAPI.dispatch(openCircularProgress());

      try {
        const response = await postData(`games/bet`, data); // Specify the type if known
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return response; // Return the fetched data
      } catch (error: any) {
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return thunkAPI.rejectWithValue(error?.message); // Handle the error appropriately
      }
  }
);

export const scheduleBet = createAsyncThunk(
  "gameEntity/scheduleBet",
  async (data: any, thunkAPI) => {
      // Open the Circular Progress
      thunkAPI.dispatch(openCircularProgress());

      try {
        const response = await postData(`games/schedule-bet`, data);
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return response;
      } catch (error: any) {
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return thunkAPI.rejectWithValue(error?.message);
      }
  }
);

// Get scheduled bets for the current user
export const getScheduledBets = createAsyncThunk(
  "gameEntity/getScheduledBets",
  async (_, thunkAPI) => {
      // Open the Circular Progress
      thunkAPI.dispatch(openCircularProgress());

      try {
        const response = await fetchData('games/schedule-bets');
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return response;
      } catch (error: any) {
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return thunkAPI.rejectWithValue(error?.message);
      }
  }
);

// Logic to save game config
export const addDynamicLimit = createAsyncThunk(
  "gameEntity/addDynamicLimit",
  async (data: any, thunkAPI) => {
      // Open the Circular Progress
      thunkAPI.dispatch(openCircularProgress());

      try {
        const response = await postData(`games/dynamicLimit`, data); // Specify the type if known
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return response; // Return the fetched data
      } catch (error) {
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return thunkAPI.rejectWithValue(error); // Handle the error appropriately
      }
  }
);

export const addManagerGamePermission = createAsyncThunk(
  "gameEntity/addManagerGamePermission",
  async (data: { manager: User; game: Game; id?: number; status?: string }, thunkAPI) => {
    thunkAPI.dispatch(openCircularProgress());

    try {
      const payload: GameManagerPermission = {
        id: data.id,
        gameDTO: data.game,
        userDTO: data.manager,
        status: data.status || 'ACTIVE',
      };
      const response = await postData(`games/manager/permission`, payload);
      thunkAPI.dispatch(closeCircularProgress());
      return response;
    } catch (error: any) {
      thunkAPI.dispatch(closeCircularProgress());
      return thunkAPI.rejectWithValue(error?.message);
    }
  }
);

export const getManagerGamePermissions = createAsyncThunk(
  "gameEntity/getManagerGamePermissions",
  async (params: { managerId?: string, gameId?: string }, thunkAPI) => {
    thunkAPI.dispatch(openCircularProgress());

    try {
      let url = 'games/manager/permission';
      if (params.managerId) url += `?managerId=${params.managerId}`;
      if (params.gameId) url += `${params.managerId ? '&' : '?'}gameId=${params.gameId}`;
      
      const response = await fetchData(url);
      thunkAPI.dispatch(closeCircularProgress());
      return response;
    } catch (error: any) {
      thunkAPI.dispatch(closeCircularProgress());
      return thunkAPI.rejectWithValue(error?.message);
    }
  }
);

const slice = createSlice({
  name: "gameEntity",
  initialState: {
    games: [] as Game[],
    gameConfigs: {
      content: [] as GameConfig[], // Array of GameConfig objects
      pageable: {}, // Pagination metadata
      totalPages: 0, // Total number of pages
      totalElements: 0, // Total number of elements
      currentPage: 0, // Current page index
    },
    activeGameConfigs: [] as GameConfig[],
    selectedGame: null as Game | null,
    managerPermissions: [] as any[],
  },
  reducers: {
    setSelectedGame: (state, action) => {
      console.log(action.payload)
      state.selectedGame = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllGames.fulfilled, (state, action) => {
      state.games = action.payload;
    });
    builder.addCase(getAllActiveGameConfigs.fulfilled, (state, action) => {
      state.activeGameConfigs = action.payload;
    });
    builder.addCase(addBet.fulfilled, (state, action) => {
      console.log(action.payload)
    })
    builder.addCase(scheduleBet.fulfilled, (state, action) => {
      console.log(action.payload)
    })
    builder.addCase(getScheduledBets.fulfilled, (state, action) => {
      // Handle the scheduled bets data if needed
      console.log('Scheduled bets:', action.payload);
    })
    builder.addCase(addDynamicLimit.fulfilled, (state, action) => {
      console.log(action.payload)
    })
    builder.addCase(getAllGameConfig.fulfilled, (state, action) => {
      state.gameConfigs = {
        ...state.gameConfigs,
        content: action.payload.content, // Store the array of GameConfig
        pageable: action.payload.pageable, // Store the pagination metadata
        totalPages: action.payload.totalPages, // Store totalPages
        totalElements: action.payload.totalElements, // Store totalElements
        currentPage: action.payload.number, // Store currentPage
      };
    });
    builder.addCase(saveGame.fulfilled, (state, action)=>{
      const newGame = action.payload;
  
      // Check if the game already exists in the state based on the game's id
      const existingGameIndex = state.games.findIndex((game) => game.id === newGame.id);
    
      if (existingGameIndex !== -1) {
        // Update existing game
        state.games[existingGameIndex] = { ...state.games[existingGameIndex], ...newGame };
      } else {
        // Add new game
        state.games.push(newGame);
      }
    });

    builder.addCase(toggleGameStatus.fulfilled, (state, action)=>{
      const newGame = action.payload;
  
      // Check if the game already exists in the state based on the game's id
      const existingGameIndex = state.games.findIndex((game) => game.id === newGame.id);
    
      if (existingGameIndex !== -1) {
        // Update existing game
        state.games[existingGameIndex] = { ...state.games[existingGameIndex], ...newGame };
      } else {
        // Add new game
        state.games.push(newGame);
      }
    });

    builder.addCase(toggleGameConfigStatus.fulfilled, (state, action)=>{
      const newGameConfig = action.payload;
  
      // Check if the game already exists in the state based on the game's id
      const existingIndex = state.gameConfigs.content.findIndex((item) => item.id === newGameConfig.id);
    
      if (existingIndex !== -1) {
        // Update existing game
        state.gameConfigs.content[existingIndex] = { ...state.gameConfigs.content[existingIndex], ...newGameConfig };
      } else {
        // Add new game
        state.gameConfigs.content.push(newGameConfig);
      }
    });

    builder.addCase(saveGameConfig.fulfilled, (state, action)=>{

      const newGameConfig = action.payload;
  
      // Check if the game already exists in the state based on the game's id
      const existingGameIndex = state.gameConfigs.content.findIndex((gameConfig: any) => gameConfig.id === newGameConfig.id);
    
      if (existingGameIndex !== -1) {
        // Update existing game
        state.gameConfigs.content[existingGameIndex] = { ...state.gameConfigs.content[existingGameIndex], ...newGameConfig };
      } else {
        // Add new game
        state.gameConfigs.content.push(newGameConfig);
      }

      // If you're paginating and need to update the pagination data, you can handle that as well
      // For example, if you're on the last page and the configuration list is getting updated:
      if (state.gameConfigs.currentPage === state.gameConfigs.totalPages - 1) {
        state.gameConfigs.totalElements += 1; // Increment totalElements
      }

    });
    builder.addCase(addManagerGamePermission.fulfilled, (state, action) => {
      const newPermission = action.payload;
      const existingIndex = state.managerPermissions.findIndex(
        (permission) => permission.id === newPermission.id
      );

      if (existingIndex !== -1) {
        // Update existing permission
        state.managerPermissions[existingIndex] = {
          ...state.managerPermissions[existingIndex],
          ...newPermission
        };
      } else {
        // Add new permission
        state.managerPermissions.push(newPermission);
      }
    });

    builder.addCase(getManagerGamePermissions.fulfilled, (state, action) => {
      state.managerPermissions = action.payload;
    });
  },
});

export const { setSelectedGame } = slice.actions;

export default slice.reducer;